/**
 * The comments AR and the enrolment team leave on a family, as the admin tables show and export them.
 * The server sends each row's comments oldest first.
 */

const pad = (n) => String(n).padStart(2, '0');

/** "07/10/2026 14:05", or the value as given if it is not a date. */
export const commentDate = (value) => {
    const date = new Date(value);
    if (!value || Number.isNaN(date.getTime())) return String(value || '');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/** The newest comment on a row, or null. */
export const latestComment = (row) => {
    const comments = row?.comments || [];
    return comments.length ? comments[comments.length - 1] : null;
};

/**
 * Every comment in one cell, for the CSV: oldest first, each with when and who, on one line so a
 * spreadsheet keeps one family to a row. "" for a family with none.
 */
export const commentsForExport = (row) => (row?.comments || [])
    .map((comment) => `${commentDate(comment.addedAt)} ${comment.addedBy || ''}: ${String(comment.note || '').replace(/\s*\n\s*/g, ' ').trim()}`)
    .join(' | ');
